export default __webpack_public_path__ + "static/media/email.04985d96.svg";